import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES } from '@/constants/trans'
import en from '@/lang/en.json'
import cn from '@/lang/cn.json'
import tr from '@/lang/tr.json'
import th from '@/lang/th.json'

Vue.use(VueI18n)

let messages = {}
if (SUPPORTED_LANGUAGES.includes('th')) {
  messages.th = th
}
if (SUPPORTED_LANGUAGES.includes('cn')) {
  messages.cn = cn
}
if (SUPPORTED_LANGUAGES.includes('tr')) {
  messages.tr = tr
}
messages.en = en

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE, // set locale
  fallbackLocale: FALLBACK_LANGUAGE,
  messages, // set locale messages
})
